import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/queries/query-keys';
import { isAlreadyChangedError } from '@/lib/admin-action-error';
import { adminsApi } from '@/lib/api';

/**
 * Suspend an admin (POST /admins/:id/suspend) — ends their access while keeping
 * their seat, so the slot count is unchanged and the row stays in the table as
 * Suspended. On success, and on a 404/409 that means it already changed, we
 * refetch the roster so the Status badge reflects server truth (TDEV-140).
 */
export function useSuspendAdmin() {
  const queryClient = useQueryClient();
  const refreshRoster = () =>
    void queryClient.invalidateQueries({ queryKey: queryKeys.admins.roster });
  return useMutation<{ id: string; suspendedAt: string }, Error, string>({
    mutationFn: (adminId) => adminsApi.suspendAdmin(adminId),
    onSuccess: refreshRoster,
    onError: (error) => {
      if (isAlreadyChangedError(error)) refreshRoster();
    },
  });
}
